import { ReactNode, createContext, useContext, useState } from "react";

type ContextType = {
	currentModal: { modal: string; step: string } | null;
	setCurrentModal: React.Dispatch<
		React.SetStateAction<{ modal: string; step: string } | null>
	>;
} | null;

export const AleloContext = createContext<ContextType>(null);

export default function AleloContextProvider({
	children,
}: {
	children: ReactNode;
}) {
	const [currentModal, setCurrentModal] = useState<{
		modal: string;
		step: string;
	} | null>(null);

	return (
		<AleloContext.Provider value={{ currentModal, setCurrentModal }}>
			{children}
		</AleloContext.Provider>
	);
}

export function useAleloContext() {
	const context = useContext(AleloContext);
	if (!context) {
		throw new Error(
			"useAleloContext must be used within a AleloContextProvider."
		);
	}

	return context;
}
